/**src\presentation\context\AuthContext\AuthContext.tsx
 * Auth Context Definition
 *
 * Defines the shape of the authentication context.
 * Contains user state and authentication methods.
 */

import { createContext } from 'react';
import type { User } from '@domain/entities';
import type { AuthResult } from '@domain/services';
import type { CreateUserDTO } from '@application/dto';

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<AuthResult>;
  createUser: (input: CreateUserDTO) => Promise<User>;
  logout: () => Promise<void>;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);
